import BannerImage from "../../Component/BannerImage/BannerImage";
import {
  Box,
  Grid,
  useTheme,
  Typography,
  CircularProgress,
} from "@mui/material";
import TruckCard from "../HomePage/Sections/Cards/TruckCard";
import { useLocation, useParams } from "react-router-dom";
import { useEffect, useMemo, useRef, useState } from "react";
import SearchSection from "../../Pages/HomePage/Sections/SearchSection";
import { API_GET_OPEN } from "../../API/config";
import { API_endpoints } from "../../API/API_Endpoints";
import Noresult from "../../Component/Noresultfound/Noresult";
import { useTranslation } from "react-i18next";
import FoodTruckEditModal from "../FoodTruckEdit/FoodTruckEditModal";
import { useInView } from "react-intersection-observer";
import CatServiceCard from "../HomePage/Sections/Cards/CatServiceCard";
import pop from "../../Assets/images/pop.webp";
import enPop from "../../Assets/images/enHomeCall.webp";
import HomeInquiryFormModal from "../HomePage/Sections/HomeInquiryFormModal";

const PAGE_SIZE = 15;

const FoodTruckScreen = () => {
  const theme = useTheme();
  const [data, setData] = useState([]);
  const location = useLocation();
  const { t, i18n } = useTranslation();
  const [open, setOpen] = useState(false);
  const [openInquiryModal, setOpenInquiryModal] = useState(false);

  const [truckData, setTruckData] = useState({});
  const [loading, setLoading] = useState(true);
  const [isLoadingMore, setIsLoadingMore] = useState(false);
  const [count, setCount] = useState(0);
  const { ref, inView } = useInView({
    threshold: 0.5,
  });
  const companyId = localStorage.getItem("Fiesta_compID");
  const [tabIndex, setTabIndex] = useState(0);
  const [totalData, setTotalData] = useState(0);
  const { tab } = useParams();
  const typeRef = useRef();
  const tabRef = useRef();
  const [commentLine, setCommentLine] = useState(location?.state?.type ?? "");

  useEffect(() => {
    if (tabRef.current !== tab) {
      setTabIndex(Number(tab));
      setCount(0);
      setData([]);
      tabRef.current = tab;
    }
  }, [tab]);

  const getData = async (
    count = 0,
    meal_ids = [],
    mealRef = [],
    diet_ids = [],
    dietRef = [],
    state_ids = [],
    state_ids_ref = [],
    type,
    _,
    is_premium,
    premiumRef = false
  ) => {
    typeRef.current = type;
    try {
      // Use different loading states for initial load vs pagination
      count === 0 ? setLoading(true) : setIsLoadingMore(true);

      if (
        JSON.stringify(meal_ids) !== JSON.stringify(mealRef) ||
        JSON.stringify(diet_ids) !== JSON.stringify(dietRef) ||
        JSON.stringify(state_ids) !== JSON.stringify(state_ids_ref) ||
        premiumRef !== is_premium
      ) {
        setCount(0);
        setData([]);
      }

      // Keep the existing parameter structure as required by the API
      const params = new URLSearchParams({
        count: count,
        // offset: PAGE_SIZE,
      });

      if (meal_ids?.length > 0) params.append("meal_ids", meal_ids);
      if (diet_ids?.length > 0) params.append("diet_ids", diet_ids);
      if (state_ids?.length > 0) params.append("state_ids", state_ids);
      if (is_premium) params.append("is_premium", 1);

      // if (typeRef.current) {
      //   const res = await API_GET_OPEN(
      //     `${
      //       API_endpoints.getAllGLobalCatererAndFoodtruck
      //     }?${params.toString()}`
      //   );

      //   if (res?.s && res?.r?.length > 0) {
      //     const totalCount = res?.r?.length || 0;

      //     setCommentLine(
      //       i18n.language === "en-US"
      //         ? `We've found <span class="fontSnugle" style="color: ${
      //             theme.palette.text.active
      //           };font-size:22px; padding: 0 0 0 5px;">${totalCount}</span>
      // <span class="fontSnugle" style="color: ${
      //   theme.palette.text.active
      // }; padding: 0 5px;">${t("foodTruck.title")}</span>
      // that match your search criteria.`
      //         : `Wir haben
      // <span class="fontSnugle" style="color: ${
      //   theme.palette.text.active
      // };font-size:22px; padding: 0 0 0 5px;">${totalCount}</span>
      // <span class="fontSnugle" style="color: ${
      //   theme.palette.text.active
      // }; padding: 0 5px;">${t("foodTruck.title")}</span>
      // gefunden, die mit Ihren Suchkriterien übereinstimmen.`
      //     );
      //   }
      // } else {
      //   setCommentLine("");
      // }

      if (typeRef.current) {
        const [truckRes, companyRes] = await Promise.all([
          API_GET_OPEN(`${API_endpoints.getalltrucks}?${params.toString()}`),
          API_GET_OPEN(`${API_endpoints.getallcaterers}?${params.toString()}`),
        ]);

        if (truckRes?.s && companyRes?.s) {
          const truckCount = truckRes?.c || 0;
          const companyCount = companyRes?.c || 0;

          setCommentLine(
            i18n.language === "en-US"
              ? `We've found <span class="fontSnugle" style="color: ${
                  theme.palette.text.active
                };font-size:22px; padding: 0 0 0 5px;">${companyCount}</span> 
        <span class="fontSnugle" style="color: ${
          theme.palette.text.active
        }; padding: 0 5px;">${t("foodTruck.title")}</span> 
        and 
         <span class="fontSnugle" style="color: ${
           theme.palette.text.active
         };font-size:22px; padding: 0 0 0 5px;">${truckCount}</span> 
        <span class="fontSnugle" style="color: ${
          theme.palette.text.active
        }; padding: 0 5px;">${t("foodTruck.Company")}</span> 
        that match your search criteria.`
              : `Wir haben 
        <span class="fontSnugle" style="color: ${
          theme.palette.text.active
        };font-size:22px; padding: 0 0 0 5px;">${companyCount}</span> 
        <span class="fontSnugle" style="color: ${
          theme.palette.text.active
        }; padding: 0 5px;">${t("foodTruck.title")}</span> 
        und 
       
               <span class="fontSnugle" style="color: ${
                 theme.palette.text.active
               };font-size:22px; padding: 0 0 0 5px;">${truckCount}</span> 
        <span class="fontSnugle" style="color: ${
          theme.palette.text.active
        }; padding: 0 5px;">${t("foodTruck.Company")}</span>  
         gefunden, die mit Ihren Suchkriterien übereinstimmen.`
          );
        }
      } else {
        setCommentLine("");
      }

      const res = await API_GET_OPEN(
        `${API_endpoints.getAllGLobalCatererAndFoodtruck}?${params.toString()}`
      );
      if (res?.s) {
        setData(res?.r);
        // if (count === 0) {
        //   setTotalData(res?.c ?? 0);
        // }
        // setCount(count + res?.r?.length);
      } else {
        setData([]);
        setCount(0);
        setTotalData(0);
      }
    } catch (error) {
      console.log(error);
      setData([]);
      setCount(0);
      setTotalData(0);
    } finally {
      // Reset both loading states
      setLoading(false);
      setIsLoadingMore(false);
    }
  };

  const openModal = async (data) => {
    setOpen(true);
    setTruckData(data);
  };

  useEffect(() => {
    window.scrollTo({ behavior: "instant", top: 0 });
  }, []);

  const mealRef = useRef(location?.state?.formValues?.meal ?? []);
  const dietRef = useRef(location?.state?.formValues?.diet ?? []);
  const stateRef = useRef(location?.state?.formValues?.state_ids ?? []);
  const premiumRef = useRef(location?.state?.formValues?.is_premium ?? false);

  useEffect(() => {
    setCount(0); // Reset count when tab changes
    getData(
      0,
      location?.state?.formValues?.meal ?? [],
      mealRef.current,
      location?.state?.formValues?.diet ?? [],
      dietRef.current,
      location?.state?.formValues?.state_ids ?? [],
      stateRef.current,
      location?.state?.type,
      typeRef.current,
      location?.state?.formValues?.is_premium,
      premiumRef.current
    );
    mealRef.current = location?.state?.formValues?.meal ?? [];
    dietRef.current = location?.state?.formValues?.diet ?? [];
    stateRef.current = location?.state?.formValues?.state_ids ?? [];
    premiumRef.current = location?.state?.formValues?.is_premium ?? false;
  }, [tabIndex]);

  const formValues = useMemo(
    () => ({
      meal: location?.state?.formValues?.meal ?? [],
      diet: location?.state?.formValues?.diet ?? [],
      state_ids: location?.state?.formValues?.state_ids ?? [],
      is_premium: location?.state?.formValues?.is_premium ?? false,
    }),
    [
      location?.state?.formValues?.meal,
      location?.state?.formValues?.diet,
      location?.state?.formValues?.state_ids,
      location?.state?.formValues?.is_premium,
    ]
  );

  useEffect(() => {
    if (inView && !loading && !isLoadingMore && count < totalData) {
      getData(
        count,
        formValues.meal,
        mealRef.current,
        formValues.diet,
        dietRef.current,
        formValues.state_ids,
        stateRef.current,
        location?.state?.type,
        typeRef.current,
        formValues.is_premium,
        premiumRef.current
      );
    }
  }, [inView, loading, isLoadingMore, count, totalData, formValues]);

  return (
    <Box>
      {/* Banner Section */}
      <BannerImage
        path={{
          title: t("contact.fiesta"),
          home: t("Navbar.Home"),
          nav: t("foodTruck.title"),
        }}
      />
      <Box
        sx={{
          background: theme.palette.background.gd,
        }}
      >
        <SearchSection
          count={count}
          values={location?.state?.formValues}
          getData={getData}
        />
        <Box
          className="flexCenter fontSnugle"
          sx={{
            textAlign: "center",
            fontSize: {
              xs: "14px",
              sm: "16px",
              md: "18px",
            },
            display: typeRef.current ? "flex" : "none",
            letterSpacing: "1px",
            padding: {
              xs: "8px",
              sm: "12px",
              md: "16px",
            },
            margin: "auto",
            maxWidth: "100%",
            wordBreak: "break-all",
            flexWrap: "wrap",
          }}
          dangerouslySetInnerHTML={{ __html: commentLine }}
        />

        <Box
          sx={{
            width: "90%",
            maxWidth: "1440px",
            m: "auto",
          }}
        >
          <Box sx={{ pb: 5, position: "relative" }}>
            <Grid container spacing={4} sx={{ justifyContent: "center" }}>
              {loading ? (
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    minHeight: "350px",
                  }}
                >
                  <CircularProgress style={{ color: "#f57c00" }} />
                </Box>
              ) : data && data?.length > 0 ? (
                <>
                  {data?.map((x, i) => {
                    const uniqueKey =
                      tabIndex === 1
                        ? `truck-${x?.id || i}`
                        : `company-${x?.company_id || i}`;
                    return (
                      <Grid
                        item
                        xs={12}
                        sm={6}
                        md={5}
                        lg={3.8}
                        key={uniqueKey}
                        sx={{
                          transition: "transform 0.3s ease-in-out",
                        }}
                      >
                        <TruckCard
                          data={x}
                          openModal={openModal}
                          title={
                            x?.company_id === Number(companyId)
                              ? t("explore.edit")
                              : t("explore.moreDetails")
                          }
                        />
                      </Grid>
                    );
                  })}
                  <Box
                    sx={{
                      width: "100%",
                      textAlign: "center",
                      my: 2,
                    }}
                    ref={ref}
                  >
                    {isLoadingMore ? (
                      <CircularProgress sx={{ color: "#f57c00" }} />
                    ) : count === totalData ? (
                      <Typography sx={{ color: "#f57c0088", mt: 1 }}>
                        {t("foodTruck.noMoreData")}
                      </Typography>
                    ) : (
                      ""
                    )}
                  </Box>
                </>
              ) : (
                !loading &&
                !isLoadingMore && (
                  <Box
                    sx={{
                      mb: 2,
                    }}
                  >
                    <Noresult />
                    <Typography
                      className="fontSnugle"
                      sx={{ textAlign: "center", fontSize: "22px" }}
                    >
                      {t("foodTruck.noData")}
                    </Typography>
                  </Box>
                )
              )}
            </Grid>
          </Box>
        </Box>
        <Box
          sx={{
            display:
              !loading && count === totalData && !isLoadingMore
                ? "flex"
                : "none",
            justifyContent: "center",
          }}
        >
          <Box
            sx={{
              maxWidth: { xs: "250px", sm: "350px", md: "320px" },
              // maxHeight: { xs: "180px", sm: "273px", md: "300px", },
              // border: "2px solid red",
              position: "static",
              right: "20px",
              // bottom: "-5px",
            }}
          >
            <img
              src={i18n?.language === "de" ? pop : enPop}
              onClick={() => setOpenInquiryModal(true)}
              style={{
                height: "100%",
                width: "100%",
                // aspectRatio: 16 / 9,
                zIndex: 100,
                cursor: "pointer",
              }}
              alt=""
            />
            <HomeInquiryFormModal
              setOpen={setOpenInquiryModal}
              open={openInquiryModal}
            />
          </Box>
        </Box>
      </Box>

      <FoodTruckEditModal
        setOpen={setOpen}
        open={open}
        data={truckData}
        getData={getData}
        compID={Number(companyId)}
      />
    </Box>
  );
};

export default FoodTruckScreen;
